import MenuStub from './MenuStub'

export default MenuStub
